import { useState } from 'react'
import { Loader } from '@googlemaps/js-api-loader'

/** Loads google core, maps, places & geometry APIs */
export const useGoogleApis = () => {
  const [isLoading, setIsLoading] = useState(false)

  const areGoogleApisLoaded =
    typeof window !== 'undefined' &&
    !!window.google?.maps &&
    !!window.google.maps.places &&
    !!window.google.maps.geometry

  /** Loads the google APIs on first load or returns state stored libs if already loaded */
  const getGoogleApis = async () => {
    if (isLoading) return Promise.resolve(null)
    if (areGoogleApisLoaded) return Promise.resolve(window.google)

    setIsLoading(true)
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    let loader: Loader

    if (!googleMapsApiKey) {
      console.error('Google Maps API key is missing')
      setIsLoading(false)
      return Promise.reject(new Error('Google Maps API key is missing'))
    }

    loader = new Loader({
      apiKey: googleMapsApiKey
    })

    try {
      // Load libraries sequentially to leverage each library's retry mechanism
      const maps = await loader.importLibrary('maps')
      const places = await loader.importLibrary('places')
      const geometry = await loader.importLibrary('geometry')

      return [maps, places, geometry]
    } catch (error) {
      // Log error but don't retry as the loader already does that
      console.error('Failed to load Google Maps libraries:', error)
      return Promise.reject(error)
    } finally {
      setIsLoading(false)
    }
  }

  return { getGoogleApis, areGoogleApisLoaded }
}
